import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { SessionInfo } from '../../Models/Models/Session/SessionInfo';

declare var IS_RUNNING_IN_APP_POOL;

export class SessionInfoClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<SessionInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Session/SessionInfo/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<SessionInfo, any>(url, data);
  }
}

